module.exports = __webpack_public_path__ + "static/media/img-mkt-banner.f3fdb852.png";